import {Typography,} from "@mui/material";
// components
import { createTheme } from "@mui/material";
import { colors } from "../../Styles/GlobalStyles/Variables";
import "./MuiTableTheme.scss";
// import EditIcon from "@mui/icons-material/Edit";
import "react-toastify/dist/ReactToastify.css";
import { styled } from "@mui/material/styles";
import Iconify from "../Dashboard/Iconify";  
import TableCell from "@mui/material/TableCell";


export const StyledTableCell = styled(TableCell)({
  paddingLeft: "40px",
  width: "250px",
});

export const ViewIcon = styled(Iconify)({
  color: colors.lightblue,
  fontSize: "18px",
});
export const EditIcon = styled(Iconify)({
  color: colors.primaryYellow,
  fontSize: "22px",
});
export const AwardIcon = styled(Iconify)({
  color: colors.purple,
  fontSize: "22px",
});

export const ActivateIcon = styled(Iconify)({
  color: colors.lightGreen,
  fontSize: "18px",
});

export const DeactivateIcon = styled(Iconify)({
  color: colors.lightRed,
  fontSize: "18px",
});

export const BlackListIcon = styled(Iconify)({
  color: colors.primaryRed,
  fontSize: "16px",
});

export const AddIcon = styled(Iconify)({
  color: colors.purple,
  fontSize: "25px",
});
export const StyledIcon = styled(Iconify)({
  color: "#637381",
  fontSize: "22px",
});
export const ActiveIcon = styled(Iconify)({
  color: colors.primaryGreen,
  fontSize: "22px",
});
export const ViewAddIcon = styled(Iconify)({
  color: colors.lightGreen,
  fontSize: "22px",
});
export const UpdateIcon = styled(Iconify)({
  color: "#5D5FEF",
  fontSize: "22px",
});


export const ColumnTextStyle = {
  textTransform: "capitalize",
  textAlign: "left",
  color: "#212b36",
  fontSize: "0.875rem",
  fontWeight: 600,
};


export const MuiDataTableTheme = createTheme({
    palette: {
      primary: {
        light: colors.lightGreen,
        main: colors.primaryGreen,
        dark: colors.darkGreen,
        contrastText: colors.white,
      },
      secondary: {
        light: colors.lightRed,
        main: colors.secondaryRed2,
        dark: colors.darkRed,
        contrastText: colors.black,
      },
    },
    typography: {
      fontFamily: Typography.secondaryFont,
      fontSize: 14,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
    },
    components: {
      MuiTableCell: {
        styleOverrides: {
          root: {
            // padding: "0px",
            backgroundColor: "none",
            borderColor: "#F1F3F4",
            padding: "10px 0px",
          },
        },
      },
      MUIDataTableHeadCell: {
        styleOverrides: {
          toolButton: {
            padding: "0px !important",
            background: "none !important",
            marginLeft: "0px !important",
          },
          sortLabelRoot: {
            background: "none !important",
          },
        },
      },
      MuiTableSortLabel: {
        root: {
          alignItems: "flex-start",
        },
      },
  
      MuiButtonBase: {
        styleOverrides: {
          root: {
            MuiButton: {
              root: {
                display: "block !important",
                MuiCheckbox: {
                  root: {
                    Mui: {
                      checked: {
                        color: "red !important",
                      },
                      MuiCheckbox: {
                        indeterminate: {
                          color: "red !important",
                        },
                      },
                    },
                  },
                },
              },
            },
  
            "&.MuiButtonBase-root-MuiButton-root": {
              justifyContent: "start !important",
              display: "block !important",
            },
          },
        },
      },
      MuiChip:{
        styleOverrides:{
          root:{
            background:'transparent',
            border: `1px solid ${colors.primaryGreen}`,
            color: colors.primaryGreen,
          },
          deleteIcon:{
            color: colors.primaryGreen,
            '&:hover':{
              color: colors.darkGreen
            },
          }
        },
      },
      MuiPopover:{
        styleOverrides:{
          paper:{
            boxShadow: '0px 4px 21px rgb(81 81 81 / 23%)',
            borderRadius:10,
            padding:'10px',
          }
        }
      },
      MuiTouchRipple: {
        styleOverrides: {
          root: {
            display: "none",
          },
        },
      },
      MUIDataTableSelectCell: {
        styleOverrides: {
        expandDisabled: {
          // Soft hide the button.
          visibility: 'hidden',
        }
        },
      },
      MUIDataTable: {
        styleOverrides: {
          responsiveBase: {
            overflowY: "hidden",
            overflowX: 'hidden',
            "&:hover": {
              overflowY: "auto",
            overflowX: 'auto',
              "&::-webkit-scrollbar": {
                width: 5,
                height: 5,
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#fff",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#DCDCDC",
                borderRadius: 2,
              },
            },
          },
        },
      },
      MUIDataTableSelectCell: {
        styleOverrides: {
          checked: { color: "#016c34 !important" },
          row: { backgroundColor: "red" },
        },
      },
      MUIDataTableBodyRow: {
        styleOverrides: {
          root: {
            "&.Mui-selected": {
              backgroundColor: "#E4F2EB !important",
            },
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            boxShadow: "none",
          },
        },
      },
  
      MuiTypography: {
        styleOverrides: {
          root: {
            color: '#050505',
            fontFamily: "Public Sans, sans-serif",
          },
          subtitle1:{
            color:colors.primaryGreen,
            fontWeight: 600,
          }
        },
      },
      MuiToolbar: {
        styleOverrides: {
          root: {
            padding: "30px",
          },
        },
      },
      MUIDataTableBodyCell: {
        root: {
          width: "200px"
        }
      }
    },
  });

  